import React, { useSyncExternalStore } from "react";
import ReactDOM from "react-dom";
import { subscribeDragGuides, getDragGuides } from "../../../../common/alignment_utils";
import "./AlignmentGuides.scss";

const COLORS = {
  "box-edge": "#7c3aed",
  "box-center": "#7c3aed",
  "canvas-edge": "#06b6d4",
  "canvas-center": "#06b6d4",
  "pixel-grid": "#94a3b8",
};

function GuideLine({ guide }) {
  const color = COLORS[guide.kind] || COLORS["box-edge"];
  const isVertical = guide.axis === "v";
  const isCenter = guide.kind.endsWith("-center");

  // 1px border-dashed renders unevenly across browsers; use a gradient.
  const dashed = (direction) =>
    `repeating-linear-gradient(${direction}, ${color} 0 4px, transparent 4px 8px)`;

  return (
    <div
      className={`align-guide align-guide--${guide.axis} align-guide--${guide.kind}`}
      style={
        isVertical
          ? {
              left: guide.pos,
              top: 0,
              bottom: 0,
              width: 1,
              background: isCenter ? dashed("to bottom") : color,
            }
          : {
              top: guide.pos,
              left: 0,
              right: 0,
              height: 1,
              background: isCenter ? dashed("to right") : color,
            }
      }
    />
  );
}

export default function AlignmentGuides() {
  const state = useSyncExternalStore(subscribeDragGuides, getDragGuides, getDragGuides);
  if (!state.active || !state.guides.length) return null;

  // Mount on the same element used as the snap-target coordinate origin.
  const targetId =
    state.containerId === "contained_maincontent" ? "contained_maincontent" : "maincontent";
  const target = document.getElementById(targetId);
  if (!target) return null;

  return ReactDOM.createPortal(
    <div className="alignment-guides-overlay" aria-hidden="true">
      {state.guides.map((g, i) => (
        <GuideLine key={`${g.axis}-${g.pos}-${i}`} guide={g} />
      ))}
    </div>,
    target
  );
}
